import _get from 'lodash/get';
import _cloneDeep from 'lodash/cloneDeep';
import _round from 'lodash/round';
import { celsiusToFahrenheit, fahrenheitToCelsius, getTemperatureUnitSuffix } from 'services/utils';
import { MEASUREMENT_SYSTEM_CHANGED_EVENT } from 'services/StudioEvents';
import { parseSampleInput, buildSamples, randomSampleInput } from '../event-samples';

// The 2nd Generation Temperature Sensor supports up to 30 samples per heartbeat
const MAX_SAMPLES = 30;

/* @ngInject */
export default class EmulatorTemperatureController {
    constructor(
        EventEmitter,
        $scope,
        $rootScope,
        $state,
        $timeout,
        UserPreferencesManager
    ) {
        this.EventEmitter = EventEmitter;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.UserPreferencesManager = UserPreferencesManager;
    }
    
    $onInit() {
        this.determineValues()

        this.inputSamplesText = ''
        this.samples = []
        this.previewVisible = false
        this.shouldIncludeSamples = false
        
        this.$rootScope.$on(MEASUREMENT_SYSTEM_CHANGED_EVENT, () => {
            this.determineValues()
        })
    }

    determineValues() {
        this.event = {
            temperature: {
                value: this.convertedTemperature(_get(this.device, 'reported.temperature.value', 0))
            }
        }
        this.min = this.convertedTemperature(-40)
        this.max = this.convertedTemperature(85)
        this.unitSuffix = getTemperatureUnitSuffix()
    }

    updateSamples() {
        const eventValue = this.event.temperature.value
        if (eventValue === null || eventValue === undefined) {
            return
        }

        const { sanitisedInput, samples } = parseSampleInput(this.inputSamplesText, eventValue, MAX_SAMPLES)
        this.inputSamplesText = sanitisedInput
        this.samples = samples

        const { samples: output, formattedSampleInterval } = buildSamples(samples, { useDummyTimestamps: true })
        this.output = output
        this.formattedSampleInterval = formattedSampleInterval

        this.outputJSON = JSON.stringify({temperature: { value: eventValue, updateTime: this.output[0].sampleTime, samples: this.output}}, null, 4)
    }

    addRandomSamples(count) { // Populates the comma separated input field with a specific number of values (centered around event value)
        this.inputSamplesText = randomSampleInput(count, this.event.temperature.value)
        this.updateSamples()
    }

    toggleEventPreview() {
        this.previewVisible = !this.previewVisible
    }

    convertedTemperature(temperature) {
        return this.UserPreferencesManager.useFahrenheit
            ? _round(celsiusToFahrenheit(temperature), 2)
            : temperature;
    }

    ensureCelsius(temperature) {
        return this.UserPreferencesManager.useFahrenheit
            ? _round(fahrenheitToCelsius(temperature), 2)
            : temperature;
    }

    sendTemperatureEvent() {
        // Send value as Celsius, keep local state if Fahrenheit
        const sendEvent = _cloneDeep(this.event)
        sendEvent.temperature.value = this.ensureCelsius(sendEvent.temperature.value)
        
        if (this.shouldIncludeSamples) {
            // Check if event should include logged samples
            const { samples } = buildSamples(this.samples) // Generate samples with real timestamps
            if (samples.length > 1) {
                sendEvent.temperature.samples = samples
                // Ensure timestamp of event and first sample is equal
                sendEvent.temperature.updateTime = samples[0].sampleTime
            }
        }
        
        this.onPublishEvent(
            this.EventEmitter({
                event: sendEvent
            })
        )
    }
}